import { Box, Typography } from '@lingoda/ui';

interface Props {
    testChargeLabel: string;
}

const TestChargeWarningSection = ({ testChargeLabel }: Props) => (
    <Box mt={2}>
        <Typography variant="body2" htmlColor="text.secondary">
            {testChargeLabel}
        </Typography>
    </Box>
);

export default TestChargeWarningSection;
